import StatsSegmentTabButton from "../StatsSegmentTabButton";
import { StyledStatsBar } from "./BoxResponsesFilterTabs.styled";

export type FilterTab = "pending" | "viewed" | "answered";

type FilterCounts = {
  pending: number;
  viewed: number;
  answered: number;
};

type BoxResponsesFilterTabsProps = {
  filter: FilterTab;
  onFilterChange: (tab: FilterTab) => void;
  counts: FilterCounts;
};

const TABS: { tab: FilterTab; label: string; countKey: keyof FilterCounts }[] = [
  { tab: "pending", label: "לא נפתחו", countKey: "pending" },
  { tab: "viewed", label: "נפתחו", countKey: "viewed" },
  { tab: "answered", label: "נענו", countKey: "answered" },
];

const BoxResponsesFilterTabs = ({
  filter,
  onFilterChange,
  counts,
}: BoxResponsesFilterTabsProps) => (
  <StyledStatsBar role="tablist" aria-label="סינון תגובות">
    {TABS.map(({ tab, label, countKey }) => (
      <StatsSegmentTabButton
        key={tab}
        selected={filter === tab}
        count={counts[countKey]}
        label={label}
        onSelect={() => onFilterChange(tab)}
      />
    ))}
  </StyledStatsBar>
);

export default BoxResponsesFilterTabs;
